// Misc APIs

import "whatwg-fetch";
import { API_URL } from "../config";
import { optionsGen } from "../helpers/api";

// News Feed

export function getNewsFeed() {
  return fetch(`${API_URL}/feed/news`, optionsGen("GET")).then(resp => resp.json());
}

// Export CSV

export function exportCSV(esUrl, esQuery, cols, email, format, xlsxFileName) {
  const uri = new URL(esUrl);
  const uriParams = uri.pathname.split("/");
  const sourceMap = {
    cases: "case",
    patents: "patent",
    repos: "repo",
    reexam: "patent"
  };
  const esParams = {
    es_source: sourceMap[uriParams[1]],
    es_index: uriParams[2],
    es_type: "_doc",
    es_query: esQuery,
    es_cols: cols,
    email,
    format,
    xlsx_filename: xlsxFileName
  };
  return fetch(`${API_URL}/helpers/schedule-csv-export`, optionsGen("POST", esParams, true)).then(resp => resp.json());
}

export async function getPdfFile(url) {
  const base64String = btoa(url)
  const response = await fetch(`${API_URL}/helpers/fetch-file?base64=${base64String}`, optionsGen("GET"));
  const arrayBuffer = await response.arrayBuffer();
  return new Uint8Array(arrayBuffer);
}

export function getDownloadUrlsFromS3(filenames, email, bucketName) {
  const url = `${API_URL}/helpers/download-files`;
  const options = optionsGen("POST", JSON.stringify({ filenames, bucket: bucketName }), false, {
    "x-email": email,
    "Content-Type": "application/json",
  });

  return fetch(url, options)
    .then((resp) => {
      if (!resp.ok) {
        return resp.json().then((err) => {
          throw err;
        });
      }
      return resp.json();
    });
}

export function deleteFilesFromS3(filenames, email, bucketName) {
  const url = `${API_URL}/helpers/delete-files`;
  const options = optionsGen("POST", JSON.stringify({ filenames, bucket: bucketName }), false, {
    "x-email": email,
    "Content-Type": "application/json",
  });

  return fetch(url, options)
    .then((resp) => {
      if (!resp.ok) {
        return resp.json().then((err) => {
          throw err;
        });
      }
      return resp.json();
    });
}

